import React, { createContext, ReactNode, useContext, useEffect } from "react";
import { _theme } from "../core/core";
import { useLocalStorage } from "../hooks/useLocalStoreg";
// Типы для темы
interface ThemeContextProps {
  theme: _theme;
  setTheme: (theme: _theme) => void;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [theme, setTheme] = useLocalStorage<_theme>(
    "kubik_theme",
    _theme.system
  );

  useEffect(() => {
    // Определение предпочтений пользователя
    if (theme === _theme.system) {
      const userPreferredTheme = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches
        ? _theme.dark
        : _theme.light;
      setTheme(userPreferredTheme);

      // Слушатель изменений системы
      const handleSystemThemeChange = (e: MediaQueryListEvent) => {
        setTheme(e.matches ? _theme.dark : _theme.light);
      };

      const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
      mediaQueryList.addEventListener("change", handleSystemThemeChange);

      return () => {
        mediaQueryList.removeEventListener("change", handleSystemThemeChange);
      };
    }
  }, [theme]);

  useEffect(() => {
    // Обновление атрибута data-theme на элементе <html>
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Хук для использования контекста
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
